import uniq from 'lodash/uniq';
import Head from 'next/head';

const DEFAULT_CSP_WHITE_LIST = [
  'https://*.zigzag.kr',
  'https://zigzag.kr',
  'https://cdn.skypack.dev',
  'https://connect.facebook.net',
  'https://www.facebook.com',
  'https://www.googletagmanager.com',
  'https://cdnjs.cloudflare.com',
  'https://t1.kakaocdn.net',
  'https://wcs.naver.net',
  'https://cdn.amplitude.com',
  'https://jscdn.appier.net',
  'https://googleads.g.doubleclick.net',
  'https://cdn.jsdelivr.net',
  'http://localhost:3000',
  'https://cdn.toss.im/oauth2/v1',
  'https://www.clarity.ms',
];

const PDP_CSP_WHITE_LIST = [
  'https://www.instagram.com',
  'https://unpkg.com',
  'https://www.youtube.com',
  'https://*.kakao.com',
  'static.airbridge.io',
  'https://d31p1exvorcj37.cloudfront.net:443/sdk/canary/airbridge.min.js',
];

export const getCSPContent = () => {
  const allowed_domains = uniq([...DEFAULT_CSP_WHITE_LIST, ...PDP_CSP_WHITE_LIST]).join(' ');
  return `child-src *; script-src 'self' ${allowed_domains} 'unsafe-eval' 'unsafe-inline'; worker-src blob:;`;
};

export function CSPHead() {
  return (
    <Head>
      <meta httpEquiv='Content-Security-Policy' content={getCSPContent()} />
    </Head>
  );
}
